import moment from "moment";
import "./ApplicantsTable.css";
import ReactStars from "react-rating-stars-component";
import { Button } from "@mui/material";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import CustomMenu from "../customMenu/CustomMenu";
import { useCallback, useState } from "react";
import { isEmpty } from "lodash";
import { config } from "../../config";
import CandidateDetails from "../candidateDetails/CandidateDetails";
import CustomDialog from "../customDialog/CustomDialog";
import {
  useFetchPaymentChannelMutation,
  useMakePaymentMutation,
} from "../../store/query/payments";
import { useTypedSelector } from "../../hook/useTypedSelector";
import DashboardModal from "../dashboardModal/DashboardModal";
import { MdCancel } from "react-icons/md";
import { _currency_format, calculateGrossAmount } from "../../utils";
import useIsMobile from "../../hook/useIsMobile";
import CompletedModal from "../completeModal/CompleteModal";
import { toast } from "react-toastify";
import { PaystackButton } from "react-paystack";
import CustomButton from "../customButton/CustomButton";
import ComplaintModal from "../complaint/Complaint";
import { useDeclineApplicantJobMutation } from "../../store/query/applicants";
import { ImCancelCircle } from "react-icons/im";
import "../completeModal/CompleteModal.css";
import { useModifyTimesheetMutation } from "../../store/query/jobs";

const ApplicantsTable = ({
  data,
  tag,
  setTag,
  status,
  updateApplicant,
  manageRefetch,
  handleResolve,
}) => {
  const { user } = useTypedSelector((store) => store.appUser);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [fetchPaymentChannel] = useFetchPaymentChannelMutation();
  const [appId, setAppId] = useState(null);
  const [open, setOpen] = useState("");
  const [details, setDetails] = useState(null);
  const isMobile = useIsMobile();
  //console.log("table", data);

  return (
    <div className="applicants-table-container">
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Rating</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.map(
            ({
              date_created,
              applicant_info,
              filled_timesheet = [],
              ...rest
            }) => {
              const currentDate = moment(date_created);
              const month = currentDate.format("MMMM");
              const date = currentDate.format("DD");
              const year = currentDate.format("YYYY");
              let appId = applicant_info?.id;
              const file =
                !isEmpty(applicant_info.cv) &&
                `${config.getPublicImages}/${applicant_info.cv}`;

              const options =
                tag === 4
                  ? [
                      {
                        name: "TimeSheet",
                        onClick: () => {
                          setDetails(filled_timesheet);
                          setOpen("TIMESHEET");
                          setAnchorEl(null);
                        },
                      },
                    ].filter(Boolean)
                  : tag === 3
                  ? [
                      {
                        name: "View CV",
                        onClick: () => {
                          setAnchorEl(null);
                          if (file) window.location.href = file;
                        },
                      },
                      {
                        name: "TimeSheet",
                        onClick: () => {
                          setDetails(filled_timesheet);
                          setOpen("TIMESHEET");
                          setAnchorEl(null);
                        },
                      },
                      selectedRow?.complain_status === "1" ||
                      selectedRow?.complain_status === "2"
                        ? {
                            name: "Resolve",
                            onClick: async () => {
                              const payload = {
                                poster_id: rest.poster_id,
                                poster_account_type: rest.poster_account_type,
                                applicant_id: applicant_info.id,
                                applicant_account_type:
                                  applicant_info.account_type,
                                payment_id: rest.payment_id,
                                complain_id: rest.complain_id,
                                _method: "PUT",
                              };
                              await handleResolve(payload);
                              setAnchorEl(null);
                            },
                          }
                        : {
                            name: "Complaint",
                            onClick: () => {
                              setOpen("COMPLAINT");
                              setAppId(appId);
                              setDetails({
                                job_id: rest.job_id,
                                app_type: applicant_info.account_type,
                              });
                              setAnchorEl(null);
                            },
                          },
                      selectedRow?.complain_status !== "1" &&
                        selectedRow?.complain_status !== "2" && {
                          name: "Completed",
                          onClick: () => {
                            setOpen("COMPLETED");
                            setAppId(appId);
                            setDetails({
                              job_id: rest.job_id,
                              app_type: applicant_info.account_type,
                            });
                            setAnchorEl(null);
                          },
                        },
                    ].filter(Boolean)
                  : tag === 2
                  ? [
                      {
                        name: "TimeSheet",
                        onClick: () => {
                          setDetails(filled_timesheet);
                          setOpen("TIMESHEET");
                          setAnchorEl(null);
                        },
                      },
                      {
                        name: "Accept",
                        onClick: async () => {
                          const res = await fetchPaymentChannel({
                            acc_type: user.account_type,
                          }).unwrap();

                          console.log('res-fetch', res)
                          
                          if (res.status) {
                            setDetails({
                              filled_timesheet,
                              amount: rest.filled_pay * 100,
                              publicKey: res.data.active[0].public_key,
                              ...applicant_info,
                              ...rest,
                            });
                            setOpen("ACCEPT");
                            setAnchorEl(null);

                            
                          }
                        },
                      },
                      {
                        name: "Modify",
                        onClick: () => {
                          setOpen("MODIFY");
                          setAppId(appId);
                          setDetails({
                            job_id: rest.job_id,
                          });
                          setAnchorEl(null);
                        },
                      },
                      {
                        name: "Decline",
                        onClick: () => {
                          setOpen("DECLINE");
                          setAppId(appId);
                          setDetails({
                            job_id: rest.job_id,
                          });
                        },
                      },
                      {
                        name: "Details",
                        onClick: () => {
                          setOpen("APP-DETAILS");
                          setAppId(appId);
                          setAnchorEl(null);
                        },
                      },
                    ]
                  : tag === 1
                  ? [
                      {
                        name: "View CV",
                        onClick: () => {
                          setAnchorEl(null);
                          if (file) window.location.href = file;
                        },
                      },
                      {
                        name: "Details",
                        onClick: () => {
                          setOpen("APP-DETAILS");
                          setAppId(appId);
                          setAnchorEl(null);
                        },
                      },
                    ]
                  : [
                      {
                        name: "View CV",
                        onClick: () => {
                          setAnchorEl(null);
                          if (file) window.location.href = file;
                        },
                      },
                      {
                        name: "Shortlist candidate",
                        onClick: () => {
                          updateApplicant({
                            option: "shortlist",
                            appId,
                          });
                          setAnchorEl(null);
                        },
                      },
                      {
                        name: "Details",
                        onClick: () => {
                          setOpen("APP-DETAILS");
                          setAppId(appId);
                          setAnchorEl(null);
                        },
                      },
                    ];

              const refilledOptions =
                status === "Complaint"
                  ? [{ name: "Resolve", onClick: () => {} }]
                  : options;

              return (
                <tr key={appId}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span>{applicant_info.name}</span>

                      {tag === 3 ? (
                        rest.complain_status === "1" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#dc2626",
                              padding: "3px 10px",
                              color: "#fff",
                              borderRadius: "24px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            <span>Complaint</span>
                          </div>
                        ) : rest.complain_status === "3" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#16a34a",
                              padding: "3px 10px",
                              color: "#fff",
                              borderRadius: "24px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            <span>Resolved</span>
                          </div>
                        ) : rest.complain_status === "2" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#a59227ff",
                              padding: "3px 10px",
                              color: "#fff",
                              borderRadius: "24px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            <span>In Progress</span>
                          </div>
                        ) : null
                      ) : null}
                    </div>
                  </td>
                  <td>
                    <ReactStars
                      count={5}
                      value={rest.locum_rating}
                      size={20}
                      activeColor="#ffd700"
                      isHalf={true}
                      edit={false}
                    />
                  </td>
                  <td>{`${date} ${month} ${year}`}</td>
                  <td>
                    <Button
                      variant="icon"
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setMenuRowId(appId);
                        setSelectedRow(rest);
                      }}
                    >
                      <HiOutlineDotsHorizontal />
                    </Button>

                    {menuRowId === appId && (
                      <CustomMenu
                        anchorEl={anchorEl}
                        handleClose={() => {
                          setAnchorEl(null);
                          setMenuRowId(null);
                        }}
                        options={refilledOptions}
                      />
                    )}
                  </td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>

      {data.length
        ? data?.map(
            ({
              date_created,
              applicant_info,
              filled_timesheet = [],
              ...rest
            }) => {
              const currentDate = moment(date_created);
              const month = currentDate.format("MMMM");
              const date = currentDate.format("DD");
              const year = currentDate.format("YYYY");
              const appId = applicant_info.id;
              const file =
                !isEmpty(applicant_info.cv) &&
                `${config.getPublicImages}/${applicant_info.cv}`;

              const options =
                tag === 4
                  ? [
                      {
                        name: "TimeSheet",
                        onClick: () => {
                          setDetails(filled_timesheet);
                          setOpen("TIMESHEET");
                          setAnchorEl(null);
                        },
                      },
                    ].filter(Boolean)
                  : tag === 3
                  ? [
                      {
                        name: "View CV",
                        onClick: () => {
                          setAnchorEl(!anchorEl);
                          if (file) window.location.href = file;
                        },
                      },
                      {
                        name: "TimeSheet",
                        onClick: () => {
                          setDetails(filled_timesheet);
                          setOpen("TIMESHEET");
                          setAnchorEl(!anchorEl);
                        },
                      },
                      rest?.complain_status === "1" ||
                      rest?.complain_status === "2"
                        ? {
                            name: "Resolve",
                            onClick: async () => {
                              const payload = {
                                poster_id: rest.poster_id,
                                poster_account_type: rest.poster_account_type,
                                applicant_id: applicant_info.id,
                                applicant_account_type:
                                  applicant_info.account_type,
                                payment_id: rest.payment_id,
                                complain_id: rest.complain_id,
                                _method: "PUT",
                              };
                              await handleResolve(payload);
                              setAnchorEl(null);
                            },
                          }
                        : {
                            name: "Complaint",
                            onClick: () => {
                              setOpen("COMPLAINT");
                              setAppId(appId);
                              setDetails({
                                job_id: rest.job_id,
                                app_type: applicant_info.account_type,
                              });
                              setAnchorEl(null);
                            },
                          },
                      rest?.complain_status !== "1" &&
                        rest?.complain_status !== "2" && {
                          name: "Completed",
                          onClick: () => {
                            setOpen("COMPLETED");
                            setAppId(appId);
                            setDetails({
                              job_id: rest.job_id,
                              app_type: applicant_info.account_type,
                            });
                            setAnchorEl(!anchorEl);
                          },
                        },
                    ].filter(Boolean)
                  : tag === 2
                  ? [
                      {
                        name: "TimeSheet",
                        onClick: () => {
                          setDetails(filled_timesheet);
                          setOpen("TIMESHEET");
                          setAnchorEl(!anchorEl);
                        },
                      },
                      {
                        name: "Accept",
                        onClick: async () => {
                          const res = await fetchPaymentChannel({
                            acc_type: user.account_type,
                          }).unwrap();
                          if (res.status) {
                            setDetails({
                              filled_timesheet,
                              amount: rest.filled_pay * 100,
                              publicKey: res.data.active[0].public_key,
                              ...applicant_info,
                              ...rest,
                            });
                            setOpen("ACCEPT");
                            setAnchorEl(!anchorEl);
                          }
                        },
                      },
                      {
                        name: "Modify",
                        onClick: () => {
                          setOpen("MODIFY");
                          setAppId(appId);
                          setDetails({
                            job_id: rest.job_id,
                          });
                        },
                      },
                      {
                        name: "Decline",
                        onClick: () => {
                          setOpen("DECLINE");
                          setAppId(appId);
                          setDetails({
                            job_id: rest.job_id,
                          });
                        },
                      },
                      {
                        name: "Details",
                        onClick: () => {
                          setOpen("APP-DETAILS");
                          setAppId(appId);
                          setAnchorEl(!anchorEl);
                        },
                      },
                    ]
                  : tag === 1
                  ? [
                      {
                        name: "View CV",
                        onClick: () => {
                          setAnchorEl(!anchorEl);
                          if (file) window.location.href = file;
                        },
                      },
                      {
                        name: "Details",
                        onClick: () => {
                          setOpen("APP-DETAILS");
                          setAppId(appId);
                          setAnchorEl(!anchorEl);
                        },
                      },
                    ]
                  : [
                      {
                        name: "View CV",
                        onClick: () => {
                          setAnchorEl(!anchorEl);
                          if (file) window.location.href = file;
                        },
                      },
                      {
                        name: "Shortlist candidate",
                        onClick: () => {
                          updateApplicant({
                            option: "shortlist",
                            appId,
                          });
                          setAnchorEl(!anchorEl);
                        },
                      },
                      {
                        name: "Details",
                        onClick: () => {
                          setOpen("APP-DETAILS");
                          setAppId(appId);
                        },
                      },
                    ];

              return (
                <div key={appId} className="mobile-table">
                  <div className="single-left">
                    <h5>Name :</h5>
                    <h5>Rating :</h5>
                    <h5>Date :</h5>
                    <h5>Action :</h5>
                  </div>
                  <div className="single-right">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span>{applicant_info.name}</span>
                      {tag === 3 ? (
                        rest.complain_status === "1" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#dc2626",
                              padding: "3px 5px",
                              color: "#fff",
                              borderRadius: "18px",
                              fontSize: "12px",
                              fontWeight: 500,
                            }}
                          >
                            <span>Complaint</span>
                          </div>
                        ) : rest.complain_status === "3" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#16a34a",
                              padding: "3px 5px",
                              color: "#fff",
                              borderRadius: "18px",
                              fontSize: "12px",
                              fontWeight: 500,
                            }}
                          >
                            <span>Resolved</span>
                          </div>
                        ) : rest.complain_status === "2" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#a59227ff",
                              padding: "3px 10px",
                              color: "#fff",
                              borderRadius: "24px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            <span>In Progress</span>
                          </div>
                        ) : null
                      ) : null}
                    </div>

                    <div>
                      <ReactStars
                        count={5}
                        value={rest.locum_rating}
                        size={15}
                        activeColor="#ffd700"
                        isHalf={true}
                        edit={false}
                      />
                    </div>
                    <span>{`${date} ${month} ${year}`}</span>
                    <div className="mobile-options">
                      {options.map((option, index) => (
                        <button
                          key={index}
                          className={`${index === 0 ? "message" : "delete"}`}
                          onClick={option.onClick}
                        >
                          {option.name}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              );
            }
          )
        : null}

      <CustomDialog
        onClose={() => setOpen("")}
        open={
          open === "APP-DETAILS" ||
          open === "COMPLETED" ||
          open === "ACCEPT" ||
          open === "COMPLAINT" ||
          open === "DECLINE" ||
          open === "MODIFY"
        }
        className="full-width-login"
      >
        {open === "APP-DETAILS" && (
          <CandidateDetails
            close={() => {
              setOpen("");
              setAppId(null);
            }}
            appId={appId}
          />
        )}

        {open === "COMPLETED" && (
          <CompletedModal
            close={() => {
              setOpen("");
              setAppId(null);
              setDetails(null);
            }}
            appId={appId}
            details={details}
            manageRefetch={manageRefetch}
          />
        )}

        {open === "ACCEPT" && (
          <AcceptModal
            close={() => {
              setOpen("");
              setAppId(null);
              setDetails(null);
            }}
            config={details}
            manageRefetch={manageRefetch}
          />
        )}

        {open === "COMPLAINT" && (
          <ComplaintModal
            close={() => {
              setOpen("");
              setAppId(null);
              setDetails(null);
            }}
            appId={appId}
            setTag={setTag}
            details={details}
            manageRefetch={manageRefetch}
          />
        )}

        {open === "DECLINE" && (
          <DeclineModal
            close={() => {
              setOpen("");
              setAppId(null);
              setDetails(null);
            }}
            appId={appId}
            setTag={setTag}
            details={details}
            manageRefetch={manageRefetch}
          />
        )}

        {open === "MODIFY" && (
          <ModifyModal
            close={() => {
              setOpen("");
              setAppId(null);
              setDetails(null);
            }}
            appId={appId}
            setTag={setTag}
            details={details}
            manageRefetch={manageRefetch}
            accType={user.account_type}
          />
        )}
      </CustomDialog>

      <DashboardModal
        onClose={() => setOpen("")}
        isOpen={open === "TIMESHEET"}
        customStyle={{
          width: isMobile ? "95%" : "80%",
        }}
      >
        <FillTimeSheet
          filled_timesheet={details}
          onClose={() => {
            setOpen("");
            setDetails(null);
          }}
          // appId={appId}
          // setTag={setTag}
          // manageRefetch={manageRefetch}
          // accType={user.account_type}
        />
      </DashboardModal>
    </div>
  );
};

export default ApplicantsTable;

const FillTimeSheet = ({ filled_timesheet, onClose }) => {
  // console.log("fill", filled_timesheet);
  //const [open, setOpen] = useState(false);
  return (
    <div className="timesheet-con">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div></div>
        <h3>Timesheet</h3>

        <MdCancel
          onClick={onClose}
          style={{ fontSize: "30px", fontWeight: 800, cursor: "pointer" }}
        />
      </div>

      <div className="timesheet-headings">
        <span>Start Date</span>
        <span>End Date</span>
        <span>Start Time</span>
        <span>End Time</span>
        <span>Hours</span>
        <span>Charges</span>
      </div>
      <div className="timesheet-result-box">
        {filled_timesheet?.map((item, i) => (
          <div key={i} className="single-candidate">
            <div className="single">
              <span className="mobile-time">Start Date:</span>
              <p>{item.start_date}</p>
            </div>
            <div className="single">
              <span className="mobile-time">End Date:</span>
              <p>{item.end_date}</p>
            </div>
            <div className="single">
              <span className="mobile-time">Start Time:</span>
              <p>{item.start_time}</p>
            </div>
            <div className="single">
              <span className="mobile-time">End Time:</span>
              <p>{item.end_time}</p>
            </div>
            <div className="single">
              <span className="mobile-time">Hours:</span>
              <p>{item.hour}</p>
            </div>
            <div className="single">
              <span className="mobile-time">Charges:</span>
              <p>{_currency_format(Number(item.charge), "NGN")}</p>
            </div>
          </div>
        ))}
      </div>

      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <CustomButton
          customStyles={{
            marginTop: "10px",
            width: "150px",
            height: "40px",
            fontSize: "16px",
            borderRadius: "5px",
          }}
          title="Modify"
          // onClick={handleSubmit}
          // disable={isLoading || message.length === 0}
          // loading={isLoading}
        />
      </div> */}

      {/* <CustomDialog
        onClose={() => setOpen("")}
        open={open}
        className="full-width-login"
      >
        <ModifyModal
          close={() => {
            setOpen("");
            setAppId(null);
            setDetails(null);
          }}
          appId={appId}
          setTag={setTag}
          details={details}
          manageRefetch={manageRefetch}
          accType={user.account_type}
        />
      </CustomDialog> */}
    </div>
  );
};

const AcceptModal = ({ close, config, manageRefetch }) => {
  const { user } = useTypedSelector((store) => store.appUser);
  const [makePayment] = useMakePaymentMutation();

  const totalHours = config.filled_timesheet.reduce(
    (acc, entry) => acc + parseInt(entry.hour),
    0
  );

  const grossAmount = calculateGrossAmount(config.amount, 1);

  const componentProps = {
    email: config.email,
    amount: grossAmount,
    metadata: {
      name: config.name,
    },
    publicKey: config.publicKey,
    onSuccess: () => onSuccess(),
    onClose: () => {
      close();
    },
  };

  const onSuccess = useCallback(async () => {
    const payload = {
      job_id: config.job_id,
      applicant_id: config.id,
      applicant_account_type: config.account_type,
      hourly_rate: config.filled_timesheet[0].hourly_rate,
      selected_hour: totalHours,
      job_pay: config.filled_pay,
      payment_channel: "paystack",
      payment_status: 1,
      acc_type: user.account_type,
    };

    const res = await makePayment(payload);
    console.log("okay done payment", res);

    if (res.data.status) {
      toast.success(res.data.message);
      close();
      await manageRefetch();
    } else {
      toast.error("Something went wrong");
    }
  }, [makePayment, close, user, totalHours, config, manageRefetch]);

  return (
    <div className="modal-completed">
      <p>Are you sure you want to accept?</p>

      <div className="btn-group-modal" style={{ marginTop: "20px" }}>
        <PaystackButton
          {...componentProps}
          style={{ border: "none", backgroundColor: "red", outline: "none" }}
        >
          <CustomButton
            customStyles={{
              width: "120px",
              height: "40px",
              marginTop: "0",
              fontSize: "14px",
              borderRadius: "5px",
            }}
            title="CONFIRM"
          />
        </PaystackButton>
        <CustomButton
          customStyles={{
            width: "120px",
            height: "40px",
            marginTop: "0",
            fontSize: "14px",
            borderRadius: "5px",
          }}
          border={"#bb2124"}
          background={"#bb2124"}
          title="CANCEL"
          onClick={close}
        />
      </div>
    </div>
  );
};

const DeclineModal = ({ close, setTag, appId, details, manageRefetch }) => {
  const { user } = useTypedSelector((store) => store.appUser);
  const [declineApplicantJob, { isLoading }] = useDeclineApplicantJobMutation();

  const handleDecline = async () => {
    const res = await declineApplicantJob({
      acc_type: user.account_type,
      job_id: details?.job_id,
      appId,
      _method: "PATCH",
    });

    if (res.data.status) {
      toast.success(res.data.message ?? "Applicant was declined Successfully");
      await manageRefetch();
      setTag(3);
    } else {
      toast.error(res.data.message ?? "Failed to decline");
    }
  };

  return (
    <div className="modal-completed">
      <p>Are you sure you want to decline?</p>

      <div
        className="btn-group-modal"
        style={{ marginTop: "20px", display: "flex", gap: "12px" }}
      >
        {/* CANCEL BUTTON */}
        <CustomButton
          customStyles={{
            width: "120px",
            height: "40px",
            marginTop: "0",
            fontSize: "14px",
            borderRadius: "5px",
          }}
          variant="outline"
          border="#6c757d"
          color="#6c757d"
          title="CANCEL"
          onClick={close}
        />

        {/* CONFIRM BUTTON */}
        <CustomButton
          customStyles={{
            width: "120px",
            height: "40px",
            marginTop: "0",
            fontSize: "14px",
            borderRadius: "5px",
          }}
          title="CONFIRM"
          onClick={handleDecline}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

const ModifyModal = ({ close, appId, details, manageRefetch, accType }) => {
  const [modifyTimesheet, { isLoading }] = useModifyTimesheetMutation();
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    const payload = {
      acc_type: accType,
      body: {
        message,
        job_id: details.job_id,
        user_id: appId,
      },
    };
    const res = await modifyTimesheet({
      ...payload,
    });

    //console.log("res", res);

    if (res.data.status) {
      toast.success(
        res.data.message ?? "Applicant Job was completed Successfully"
      );
      close();
      await manageRefetch();
    } else {
      toast.error("Failed to completed applicant job");
    }
  };

  return (
    <div className="complete-modal-container">
      <ImCancelCircle className="icon-can" onClick={close} />
      <div className="complete-modal-content">
        <div className="header">
          <h4>Modify Timesheet</h4>
        </div>

        <div className="main-content">
          <div className="text-field">
            <label>
              Kindly specify the exact changes you want the professional to make
              to their timesheet selection.
            </label>
            <textarea
              cols="10"
              rows="3"
              placeholder="Type Reasons"
              disabled={isLoading}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>

          <CustomButton
            customStyles={{
              marginTop: "10px",
              width: "100%",
              height: "40px",
              fontSize: "16px",
              borderRadius: "5px",
            }}
            title="Submit"
            onClick={handleSubmit}
            disable={isLoading || message.length === 0}
            loading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
